import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Italic: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['line', { x1: '19', x2: '10', y1: '4', y2: '4' }],
    ['line', { x1: '14', x2: '5', y1: '20', y2: '20' }],
    ['line', { x1: '15', x2: '9', y1: '4', y2: '20' }],
  ],
];

export default Italic;
